import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
  },
  {
    path: '/ru/u/:username',
    redirect: { name: 'User' }
  },
  {
    path: '/ru/:username',
    name: 'User',
    props: true,
    component: () => import(/* webpackChunkName: "user" */ '@/views/User.vue')
  },
  {
    path: '/u/:username',
    redirect: { name: 'User' }
  },
  {
    path: '/rr/r/:subreddit',
    redirect: { name: 'Subreddit' }
  },
  {
    path: '/rr/:subreddit',
    name: 'Subreddit',
    props: true,
    component: () => import(/*webpackChunkName: "subreddit" */ '@/views/Subreddit.vue')
  },
  {
    path: '/r/:subreddit',
    redirect: { name: "Subreddit" }
  },
  {
    path: '/acknowledgements',
    name: 'Acknowledgements',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "acknowledgements" */ '@/views/Acknowledgements.vue')
  },
  {
    path: '/cart',
    name: 'Cart',
    component: () => import(/* webpackChunkName: "cart" */ '@/views/Cart.vue')
  },
  {
    path: '*',
    name: '404',
    props: (route) => { return { path : route.path} },
    component: () => import(/* webpackChunkName: "404page" */ '@/views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
